import { render, staticRenderFns } from "./IndexComponent.vue?vue&type=template&id=f8831d96&scoped=true&"
import script from "./IndexComponent.vue?vue&type=script&lang=js&"
export * from "./IndexComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8831d96",
  null
  
)

export default component.exports